import { Pipe, PipeTransform } from '@angular/core';
import { compactInteger } from './_humanize';

@Pipe({
  name: 'sgHumanNum',
  standalone: false,
})
export class SgHumanNumPipe implements PipeTransform {
  /**
   * Converts a number to a human readable form, e.g. 11000000 -> 11M
   * @param value The number to convert
   * @param decimals The OUTPUT number of digists after the decimal point, e.g 77522239 with decimals 2 -> 77.52M
   * @param jsRoundingDecimals The INPUT of digists after the decimal point. This will control the input value passed to the
   * converter, e.g 77522239.37253672 with jsRoundingDecimals of 0 will send 77522239 to the transformer.
   * This is used in large number with decimal value which may cause unexpected outputs.
   */
  transform(value: number, decimals: number = 0, jsRoundingDecimals: number = 0, forceDecimal = true): string {
    return SgHumanNumPipe.transform(value, decimals, jsRoundingDecimals, forceDecimal);
  }

  /**
   * Converts a number to a human readable form, e.g. 11000000 -> 11M
   * @param value The number to convert
   * @param decimals The OUTPUT number of digists after the decimal point, e.g 77522239 with decimals 2 -> 77.52M
   * @param jsRoundingDecimals The INPUT of digists after the decimal point. This will control the input value passed to the
   * converter, e.g 77522239.37253672 with jsRoundingDecimals of 0 will send 77522239 to the transformer.
   * This is used in large number with decimal value which may cause unexpected outputs.
   */
  static transform(value: number, decimals: number = 0, jsRoundingDecimals: number = 0, forceDecimal = true): string {
    value = Number(Math.round((value + 'e' + jsRoundingDecimals) as any) + 'e-' + jsRoundingDecimals);
    return compactInteger(value, decimals, forceDecimal);
  }
}
